import { makeStyles } from '@material-ui/styles';
const BUTTON_SIZE = 40;
const useStyles = makeStyles((theme) => ({
    textField: {
        fontWeight: theme.font.weight.bold,
        width: '100%',
        height: BUTTON_SIZE,
        flex: '1 0 auto',
        borderRadius: 0,
        borderLeft: 'none',
        borderRight: 'none',
        borderTop: `1px solid ${theme.color.grey.light}`,
        borderBottom: `1px solid ${theme.color.grey.light}`,
        boxSizing: 'border-box',
        alignItems: 'center',
        justifyContent: 'center',
        '&:hover, &:focus': {
            borderColor: `${theme.color.grey.default}`,
            outline: 'none',
        },
    },
    textFieldInvalid: {
        borderColor: theme.color.error.main,
        color: theme.color.error.main,
    },
    input: {
        padding: 0,
        textAlign: 'center',
        '-moz-appearance': 'textfield',
        '&::-webkit-inner-spin-button, &::-webkit-outer-spin-button': {
            '-webkit-appearance': 'none',
            margin: 0,
        },
    },
    label: {
        color: 'currentColor',
        height: 16,
        minWidth: 100,
        fontSize: theme.font.size.mediumSmall,
        fontWeight: 400,
    },
    button: {
        width: BUTTON_SIZE,
        height: BUTTON_SIZE,
        minWidth: BUTTON_SIZE,
        maxWidth: BUTTON_SIZE,
        boxShadow: 'none',
        fontSize: 30,
        fontWeight: theme.font.weight.light,
        paddingBottom: 12,
        lineHeight: 0,
        '&:first-child': {
            borderRadius: '5px 0 0 5px',
        },
        '&:last-child': {
            borderRadius: '0 5px 5px 0',
        },
    },
    buttonDisabled: {
        background: theme.color.grey.light,
        pointerEvents: 'none',
    },
    suffix: {
        fontSize: theme.font.size.mediumSmall,
        color: 'currentColor',
        opacity: 0.58,
        whiteSpace: 'nowrap',
    },
}));
export default useStyles;
//# sourceMappingURL=PlusMinusInputStyles.js.map